import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { Colors } from "../../../helpers/Colors";
import { fontSize } from "../../../helpers/fontSize";
import { TiUserAdd } from "react-icons/ti";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

const useStyles = makeStyles({
  AddEmployee: {
    backgroundColor: Colors.primaryLight,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  Employee: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 60px",
    // backgroundColor: Colors.primary,
    fontSize: fontSize.question,
    "& .Header": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontWeight: 600,
      "& .number": {
        width: "auto",
        height: "auto",
        padding: "8px 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.primary,
        // borderRadius: "20px",
        "& .iconCon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // cursor: "pointer",
          "& .icon": {
            width: "25px",
            height: "26px",
          },
        },
      },
      "& .question_chevron": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: Colors.white,
        padding: "0px 15px",
        "& .question": {
          padding: "8px",
          //   backgroundColor: "blue",
        },
        "& .rightCon": {
          display: "flex",
          padding: "8px 0px 8px 8px",
          "& .selected": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 500,
            fontSize: fontSize.selected,
            color: Colors.grey,
            "& span": {
              margin: "0px 5px",
              color: Colors.success,
              // color: (props) => props.cabinName === Cabins.cabin1 ? `${Colors.tom}` :  `${Colors.jerry}`,
            },
          },
          "& .iconCon": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // cursor: "pointer",
            "& .icon": {
              width: "25px",
              height: "25px",
            },
          },
        },
      },
    },
    "& .Body": {
      "& .BodyCon": {
        padding: "20px",
        "& .allTimes": {
          display: "flex",
          flexDirection: "row",
          width: "fit-content",
          padding: "10px",
        },
      },
    },
  },
  DetailsCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    // backgroundColor: Colors.tom,
  },
  Cabin_Date: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexDirection: "row",
    // backgroundColor: Colors.tyke,
    width: "600px",
    "& .Cabin": {
      // backgroundColor: Colors.tom,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexDirection: "column",
      width: "280px",
      padding: "0 0 8px 0",
      "& label": {
        fontSize: fontSize.label,
        color: Colors.greySteel,
        fontWeight: 500,
        margin: "0px",
        padding: "0px",
      },
      "& input": {
        width: "100%",
        padding: "5px 10px",
        color: Colors.secondary,
        // fontWeight: 400,
        fontSize: fontSize.reservationDetails,
        borderRadius: "5px",
        border: `1px solid ${Colors.primary}`,
        backgroundColor: Colors.white,
        outline: "none",
      },
    },
  },
});

const AddEmployee = () => {
  const classes = useStyles();

  const [dyootiID, setDyootiID] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  const onSubmitEmployee = (e) => {
    e.preventDefault();
    const postData = {
      dyootiID,
      employeeName,
    };
    axios
      .post("/api/post/addEmployee", postData)
      .then((res) => {
        return console.log("Result", res);
      })
      .catch((err) => {
        return console.log("Error", err);
      });
    toast(`Hello ${postData}`);
  };

  return (
    <section className={classes.Employee}>
      {/* <Toaster /> */}
      <main
        className="Header"
        //   onClick={onCabinHeaderClick}
      >
        <section className="number">
          <div className="iconCon">
            <TiUserAdd className="icon" />
          </div>
        </section>
        <section className="question_chevron">
          <div className="question">Add an Employee</div>
          <div className="rightCon">
            {/* <div className="selected">
              Time:
              <span
              // dateTime={format(selectedTime, "hh-mm-ss-ms")}
              // className={`${
              //   cabinName === Cabins.cabin1
              //     ? classes.cabin1
              //     : cabinName === Cabins.cabin2
              //     ? classes.cabin2
              //     : cabinName === Cabins.cabin3
              //     ? classes.cabin3
              //     : classes.cabin4
              // }`}
              >
                {selectedTime}
              </span>
            </div> */}
            {/* {selectedTime !== "" ? (
              <div className={classes.CheckIconCon}>
                <BsCheck className="icon" />
              </div>
            ) : (
              <div className={classes.EmptyCheckIconCon}>
                <BsCheck className="emptyIcon" />
              </div>
            )} */}

            {/* <div className="iconCon">
              <HiChevronDown
                style={{
                  transform: rotateCabinChev,
                  transition: "0.3s linear",
                }}
                className="icon"
              />
            </div> */}
          </div>
        </section>
      </main>
      <form onSubmit={onSubmitEmployee} className="Body">
        <section className="BodyCon max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6">
          <main className={classes.DetailsCon}>
            <section className={classes.Cabin_Date}>
              <div className="Cabin">
                <label>Dyooti ID</label>
                <input
                  className=""
                  type={"text"}
                  value={dyootiID}
                  onChange={(e) => setDyootiID(e.target.value)}
                />
              </div>
              {/* {JSON.stringify(dyootiID)}
              {JSON.stringify(employeeName)} */}
              <div className="Cabin">
                <label>Name</label>
                <input
                  className=""
                  type={"text"}
                  value={employeeName}
                  onChange={(e) => setEmployeeName(e.target.value)}
                />
              </div>
            </section>
          </main>
        </section>
        <button
          type="submit"
          className="flex items-center justify-end bg-primary w-fit p-2 rounded-md float-right cursor-pointer"
          // onClick={slideToDatePrevious}
        >
          <div className="flex items-center justify-center">
            <TiUserAdd className="w-6 h-6 pr-1" />
          </div>
          <div className="text-base font-semibold px-1">Add</div>
        </button>
      </form>
    </section>
  );
};

export default AddEmployee;
